import React from 'react';
import MUIDataTable, { MUIDataTableOptions } from 'mui-datatables';
import { labels } from './labels';
import { ITable } from './interfaces';
import { useStyles } from './styles';

export const Table = (props: ITable) => {
  const classes = useStyles();
  const { columns, data, title, options, nameCSV, size } = props;

  const customOptions: MUIDataTableOptions = {
    serverSide: options?.serverSide || false,
    count: options?.count,
    sortOrder: options?.sortOrder,
    filter: options?.filter || true,
    search: options?.search || true,
    sort: options?.sort || true,
    download: options?.download || true,
    sortFilterList: options?.sortFilterList || true,
    viewColumns: options?.viewColumns || true,
    print: options?.print || false,
    filterType: 'textField',
    selectableRows: options?.selectableRows || 'none',
    onRowClick: options?.onRowClick,
    onCellClick: options?.onCellClick,
    customSort: options?.customSort,
    customToolbar: options?.customToolbar,
    customToolbarSelect: options?.customToolbarSelect,
    customFooter: options?.customFooter,
    //onRowsSelect: onRowsSelect,
    elevation: options?.elevation || 1,
    onTableChange: options?.onTableChange,
    onChangePage: options?.onChangePage,
    //onRowsPerPageChange: onChangeRowsPerPage,
    rowsPerPage: options?.rowsPerPage || 15,
    rowsPerPageOptions: options?.rowsPerPageOptions || [15],
    responsive: options?.responsive || 'simple',
    pagination: options?.pagination || true,
    rowHover: options?.rowHover || true,
    textLabels: labels,
    customRowRender: options?.customRowRender,
    setRowProps: options?.setRowProps,
    downloadOptions: {
      filename: !nameCSV ? `${title}.csv` : `${nameCSV}.csv`,
      separator: ';'
    },
    fixedHeaderOptions: { xAxis: true, yAxis: true },
    onDownload: (buildHead, buildBody, columns, data) => {
      return '\uFEFF' + buildHead(columns) + buildBody(data);
    },
    setTableProps: () => {
      return {
        size: size || 'small'
      };
    }
  };

  return (
    <div className={classes.root}>
      <MUIDataTable title={title} data={data} columns={columns} options={customOptions} />
    </div>
  );
};
